export default "__VITE_ASSET__BMH0G2rl__"